import { gql } from "urql"

export const UPLOAD_PORTAL_DOCUMENT_MUTATION = gql`
  mutation UploadPortalDocument(
    $handle: String!
    $url: String!
    $filename: String!
    $contentType: String!
    $provider: String
    $byteSize: Int
  ) {
    uploadPortalDocument(
      handle: $handle
      url: $url
      filename: $filename
      contentType: $contentType
      provider: $provider
      byteSize: $byteSize
    ) {
      result
      errors
      document {
        id
        url
        filename
        handle
        contentType
        provider
      }
    }
  }
`
